import cuid from "cuid";
import { defaults, get, isEmpty, keyBy, map } from "lodash";
import { useMemo } from "react";
import {
  CLIENT_CATEGORY,
  CONTACT_POINT_SYSTEM,
  SOCIAL_REGIMES,
} from "utils/constants";
import Template from "../Template";
import View from "./View";

const AdherentInfo = ({ project, currentStatus, onNext, onBack }) => {
  const next = ({ contact = {}, contract = {}, fields = {} }) => {
    const mappedTelecoms = map(get(contact, "telecoms"), (item, key) =>
      defaults(item, { id: cuid(), system: key })
    ).filter((item) => !isEmpty(item.value));

    const payload = {
      contact: isEmpty(contact)
        ? undefined
        : {
          ...contact,
          telecoms: mappedTelecoms,
        },
      contract: isEmpty(contract) ? undefined : contract,
      fields: isEmpty(fields) ? undefined : fields,
    };
    onNext({ payload });
  };

  const initialValues = useMemo(() => {
    const profile = get(project, "contact.fields.profile");

    return {
      contact: {
        ...get(project, "contact", {}),
        socialRegime:
          get(project, "contact.socialRegime") ??
          SOCIAL_REGIMES.SECURITE_SOCIALE,
        telecoms: defaults(keyBy(get(project, "contact.telecoms"), "system"), {
          [CONTACT_POINT_SYSTEM.ZIP_CODE]: { value: null },
        }),
        fields: {
          ...get(project, "contact.fields", {}),
          isClient: false,
        },
      },
      contract: get(project, "contract"),
      fields: {
        ...get(project, "fields", {}),
        info: {
          ...get(project, "fields.info", {}),
          cssBeneficiary:
            profile === CLIENT_CATEGORY.PARTICULAR
              ? get(project, "fields.info.cssBeneficiary", false)
              : undefined,
        },
      },
    };
  }, []);

  return (
    <Template
      progress={currentStatus.progress}
      // onBack={onBack}
      View={
        <View
          onNext={next}
          initialValues={initialValues}
          locked={project.locked}
          onBack={onBack}
        />
      }
    />
  );
};

export default AdherentInfo;
